type Listener = (...args: any[]) => void

class EventEmitter {
  private listeners: Map<string, Set<Listener>> = new Map()

  addListener(event: string, listener: Listener): void {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set())
    }
    this.listeners.get(event)!.add(listener)
  }

  removeListener(event: string, listener: Listener): void {
    this.listeners.get(event)?.delete(listener)
  }

  removeAllListeners(event?: string): void {
    if (event) {
      this.listeners.delete(event)
    } else {
      this.listeners.clear()
    }
  }

  emit(event: string, ...args: any[]): void {
    this.listeners.get(event)?.forEach(listener => {
      listener(...args)
    })
  }
}

export default EventEmitter
